var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubcard5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 51,
    viewBox: "0 0 142 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1_16434)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 20.5,
    r: 5.5,
    fill: "#FF881B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 131.5,
    cy: 20.5,
    r: 5,
    stroke: "#FF881B"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.00049 49.5L9.84774 26.5L19.8746 37L25.7728 19.5L36.3895 37L52.3145 3L67.6498 26.5L84.7544 19.5L98.3202 31L110.117 6.5L118.964 19.5H130.5",
    stroke: "#FF881B",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1_16434",
    x: 121,
    y: 10,
    width: 21,
    height: 21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_1_16434"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubcard5);
export default __webpack_public_path__ + "static/media/subcard5.09f10ec09ec46f7f921487c71402cf3d.svg";
export { ForwardRef as ReactComponent };